




































































































import ModalBox from '@/modules/core/components/ModalBox.vue';
import { agencyApi } from '../agency.api';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component } from 'vue-property-decorator';
import { PaginationResult, PermissionType } from '@shared/common/types';
import { Agency } from '../agency';

@Component({
  components: {
    ModalBox,
  },
})
export default class AgenciesTable extends BaseTable {
  public PermissionType: typeof PermissionType  = PermissionType;
  public async fetchData(): Promise<PaginationResult<Agency>> {
    return await agencyApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }
}
